import Plugin from './index';
import lifecycle from 'page-lifecycle';
import { startUploadInterval, clearUploadInterval } from '../upload';
import { getReportInfo } from '../helpers';
import Cache from '../cache';
import store from '../../../store';
import { DEFAULT_REPORT_EXCLUDE } from '../../../config/constants';

const targetCache = new Cache(500);

class ReportPlugin extends Plugin {
  name = 'report';

  init() {
    const { enableReport, include, exclude, enableDefaultReport } = store.config;
    if (enableReport) {
      // 批量间隔上报
      startUploadInterval();
      lifecycle.addEventListener('statechange', (e: any) => {
        // 页面隐藏时上报数据，清除计时器
        if (e.oldState === 'passive' && e.newState === 'hidden') {
          clearUploadInterval();
        }
        // 页面可见时，重新设置计数器
        if (e.oldState === 'hidden' && e.newState === 'passive') {
          startUploadInterval();
        }
        // 暂时屏蔽，计算页面时长后统一上报
        // if (['frozen', 'terminated'].includes(e.newState)) {
        //   uploadAll();
        // }
      });

      // 点击事件监听
      window.document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        // 避免重复上报
        if (targetCache.has(target)) return;
        targetCache.put(target);

        // 上报
        const reportInfo = getReportInfo(e, {
          include,
          exclude: [...DEFAULT_REPORT_EXCLUDE, ...exclude || []],
          enableDefaultReport,
        });
        if (reportInfo) {
          this.instance.reportAction(reportInfo);
        }
      });
    }
  }
}

export default ReportPlugin;
